import apiPaths from '../../api-paths';

export default {
    get(id) {
        return axios.get(`${apiPaths.CRM}/mail-templates/${id}`);
    },
    save(data) {
        return axios.put(`${apiPaths.CRM}/mail-templates`, data);
    },
}